import type { DieFace } from './face.type';
import type { Stances } from './status-effects/stance';
import type { AmmoType } from './ammo.type';
import { StatusEffect } from './status-effects.type';
import type { Songs } from './status-effects/song';

export enum ModifierPriority {
  First = 0,
  Early = 1,
  Middle = 5,
  Late = 10,
  Last = 11,
}

export interface ModifierParams {
  imbue?: StatusEffect;
  infusion?: DieFace;
  ammoType?: AmmoType;
  stance?: Stances;
  propagate?: boolean;
  role?: 'performer' | 'listener';
  song?: Songs;
  duration?: number;
}

export enum ModifierTags {
  Boon = 'boon',
  Bane = 'bane',
  DamageModifier = 'damage-modifier',
  HealingModifier = 'healing-modifier',
  Temporary = 'temporary',
  Persistent = 'persistent',
  Ammo = 'ammo',
  Song = 'song',
}

export { StatusEffect };
